<template>
<div>
    <!-- modal -->
    <b-modal id="ledesExcelReadFormModal" centered size="lg" no-close-on-backdrop ref="ledesExcelReadFormModal" :title="$t('ledesExcelRead.title')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="saveLedesExcel">
        <validation-observer ref="simpleRules">
            <b-row>
                <b-col class="col-lg-8">
                    <validation-provider #default="{ errors }" :name=" $t('ledesExcelRead.folder_name')" rules="required">
                        <label for="agent-annuity-folder-name-input">{{ $t('ledesExcelRead.folder_name') }}</label>
                        <b-input-group>
                            <b-form-input size="sm" id="folder-name-input" v-model="documentName" maxlength="50" :state="errors.length > 0 ? false:null" />
                            <b-input-group-append>
                                <b-button size="sm" variant="outline-primary" onclick="document.getElementById('ledesExcelFileSelect').click()">{{ $t('others.select') }}
                                </b-button>
                                <b-form-file size="sm" style="display:none" id="ledesExcelFileSelect" accept="*.*" @change="uploadLedesExcel" :placeholder=" $t('ledesExcelReadForm.select_folder')" :drop-placeholder=" $t('ledesExcelReadForm.select_folder_info')" />
                            </b-input-group-append>
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-col>

            </b-row>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getLedesDetailList: {
            type: Function
        },
    },
    data() {
        return {
            ledesId: 0,
            documentName: '',
            documentFile: '',
            documentType: '',
        }
    },
    methods: {
        showInfo(ledesId) {
            this.$refs['ledesExcelReadFormModal'].show()
            this.ledesId = ledesId
        },
        async uploadLedesExcel(e) {
            var fileInfo = await this.$getFileInfo(e.target.files[0])
            this.documentName = fileInfo.name
            this.documentType = fileInfo.contentType
            this.documentFile = fileInfo.base64
        },
        async saveLedesExcel() {
            this.$refs.simpleRules.validate().then(success => {
                const data = {
                    ledesId: this.ledesId,
                    base64File: this.documentFile,
                    documentType: this.documentType,
                    employeeId: localStorage.getItem('EmployeeId'),
                }

                const controller = {
                    name: 'Ledes',
                    actionName: 'ReadLedesExcelFile'
                }
                const payload = {
                    data: data,
                    controller: controller
                }

                if (success) {
                    let loader = this.$loading.show()
                    this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('ledesExcelReadFormModal')
                            this.$SaveAlert()
                            this.getLedesDetailList()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                        loader.hide()
                    })
                }
            })
        },
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
